import { TemplateIdsMap, TemplateIdsMapBC } from "@finbackoffice/fe-core";

export const horizontalOutcomeVariantTemplateIds = [
    TemplateIdsMap.BOTH_TEAMS_TO_SCORE_1ST_HALF,
    TemplateIdsMap.COMPETITOR1_CLEAN_SHEET_1ST_HALF,
    TemplateIdsMap.COMPETITOR2_CLEAN_SHEET_1ST_HALF,
    TemplateIdsMap.BOTH_TEAMS_TO_SCORE_2ND_HALF,
    TemplateIdsMap.COMPETITOR1_CLEAN_SHEET_2ND_HALF,
    TemplateIdsMap.COMPETITOR2_CLEAN_SHEET_2ND_HALF,
    TemplateIdsMap.ODD_EVEN_2ND_HALF,
    TemplateIdsMap.ODD_EVEN_1ST_HALF,
    TemplateIdsMap.WHEN_WILL_1ST_GOAL_BE_SCORED_15MIN,
    TemplateIdsMap.WHEN_WILL_1ST_GOAL_BE_SCORED_10MIN,
    TemplateIdsMap.BOTH_HALVES_OVER_AMOUNTNUMBER,
    TemplateIdsMap.BOTH_HALVES_UNDER_AMOUNTNUMBER,
    TemplateIdsMap.ODD_EVEN,
    TemplateIdsMap.COMPETITOR1_ODD_EVEN,
    TemplateIdsMap.COMPETITOR2_ODD_EVEN,
    TemplateIdsMap.BOTH_TEAMS_TO_SCORE,
    TemplateIdsMap.COMPETITOR1_CLEAN_SHEET,
    TemplateIdsMap.COMPETITOR2_CLEAN_SHEET,
    TemplateIdsMap.COMPETITOR1_WIN_TO_NIL,
    TemplateIdsMap.COMPETITOR2_WIN_TO_NIL,
    TemplateIdsMap.COMPETITOR1_TO_WIN_BOTH_HALVES,
    TemplateIdsMap.COMPETITOR2_TO_WIN_BOTH_HALVES,
    TemplateIdsMap.COMPETITOR1_TO_WIN_EITHER_HALF,
    TemplateIdsMap.COMPETITOR2_TO_WIN_EITHER_HALF,
    TemplateIdsMap.COMPETITOR1_TO_SCORE_IN_BOTH_HALVES,
    TemplateIdsMap.COMPETITOR2_TO_SCORE_IN_BOTH_HALVES,
    TemplateIdsMap.HALFTIME_FULLTIME_CORRECT_SCORE,
    TemplateIdsMap.WILL_THERE_BE_OVERTIME,
    TemplateIdsMap.ODD_EVEN_2ND_QUARTER,
    TemplateIdsMap.ODD_EVEN_INCL_OVERTIME,
    TemplateIdsMap.ODD_EVEN_INCL_OVERTIME_2ND_HALF,
    TemplateIdsMap.ODD_EVEN_INCL_EXTRA_INNINGS,
    TemplateIdsMap.WILL_THERE_BE_EXTRA_INNING,
    TemplateIdsMap.COMPETITOR2_TOTAL_INNINGNUMBER,
    TemplateIdsMap.COMPETITOR1_TOTAL_INNINGNUMBER,
    TemplateIdsMap.SETNUMBER_SET_TOTAL_POINTS,
    TemplateIdsMap.SETNUMBER_ODD_EVEN,
    TemplateIdsMap.TOTAL_POINTS,
    TemplateIdsMap.WILL_THERE_BE_4TH_SET,
    TemplateIdsMap.WILL_THERE_BE_5TH_SET,
    TemplateIdsMap.ODD_EVEN_INCL_OVERTIME_PENALTIES,
    TemplateIdsMap.PERIODNUMBER_PERIOD_TOTAL,
    TemplateIdsMap.PERIODNUMBER_PERIOD_BOTH_TEAMS_TO_SCORE,
    TemplateIdsMap.PERIODNUMBER_ODD_EVEN,
    TemplateIdsMap.ANY_SET_TO_NIL,
    TemplateIdsMap.WILL_THERE_BE_TIEBREAK,
    TemplateIdsMap.ODD_EVEN_GAMES,
    TemplateIdsMap.SETNUMBER_ODD_EVEN_GAMES,
    TemplateIdsMap.SETNUMBER_GAMENUMBER_TO_DEUCE,
    TemplateIdsMap.SETNUMBER_GAMENUMBER_EXACT_POINTS,
    TemplateIdsMap.WILL_THERE_BE_TIEBREAK_SETNUMBER,
    TemplateIdsMap.COMPETITOR1_TO_WIN_A_SET,
    TemplateIdsMap.COMPETITOR2_TO_WIN_A_SET,
    TemplateIdsMap.GAME_GAMENUMBER_TOTAL_POINTS,
    TemplateIdsMap.GAME_GAMENUMBER_ODD_EVEN,
    TemplateIdsMap.WILL_THERE_BE_OVERTIME_MAPNUMBER,
    TemplateIdsMap.TOTAL_MAPS,
    TemplateIdsMap.TOTAL,
    TemplateIdsMap.COMPETITOR1_TOTAL,
    TemplateIdsMap.COMPETITOR2_TOTAL,
    TemplateIdsMap.TOTAL_1ST_HALF,
    TemplateIdsMap.TOTAL_2ND_HALF,
    TemplateIdsMap.TOTAL_1ST_HALF_COMPETITOR1,
    TemplateIdsMap.TOTAL_1ST_HALF_COMPETITOR2,
    TemplateIdsMap.TOTAL_2ND_HALF_COMPETITOR1,
    TemplateIdsMap.TOTAL_2ND_HALF_COMPETITOR2,
    TemplateIdsMap.TOTAL_GAMES,
    TemplateIdsMap.TOTAL_GAMES_COMPETITOR1,
    TemplateIdsMap.TOTAL_GAMES_COMPETITOR2,
    TemplateIdsMap.SETNUMBER_SET_TOTAL_GAMES,
    TemplateIdsMap.TOTAL_INCL_EXTRA_INNINGS,
    TemplateIdsMap.INNINGNUMBER_INNING_TOTAL,
    TemplateIdsMap.COMPETITOR1_TOTAL_INCL_EXTRA_INNINGS,
    TemplateIdsMap.COMPETITOR2_TOTAL_INCL_EXTRA_INNINGS,
    TemplateIdsMap.COMPETITOR1_TOTAL_INCL_OVERTIME,
    TemplateIdsMap.COMPETITOR2_TOTAL_INCL_OVERTIME,
    TemplateIdsMap.TOTAL_OVER_EXACT_UNDER,
    TemplateIdsMap.QUARTERNUMBER_QUARTER_TOTAL,
    TemplateIdsMap.QUARTERNUMBER_QUARTER_COMPETITOR1_TOTAL,
    TemplateIdsMap.QUARTERNUMBER_QUARTER_COMPETITOR2_TOTAL,
];

export const horizontalOutcomeVariantTemplateIdsBC = [
    TemplateIdsMapBC.SOCCER_TOTAL,
    TemplateIdsMapBC.BASKETBALL_TOTAL,
    TemplateIdsMapBC.BASKETBALL_3X3_TOTAL,
    TemplateIdsMapBC.BASEBALL_TOTAL,
    TemplateIdsMapBC.TENNIS_TOTAL,
    TemplateIdsMapBC.HANDBALL_TOTAL,
    TemplateIdsMapBC.ICE_HOCKEY_TOTAL,
    TemplateIdsMapBC.FLOORBALL_TOTAL,
    TemplateIdsMapBC.BOXING_TOTAL,
    TemplateIdsMapBC.RUGBY_LEAGUE_TOTAL,
    TemplateIdsMapBC.RUGBY_UNION_TOTAL,
    TemplateIdsMapBC.RUGBY_SEVENS_TOTAL,
    TemplateIdsMapBC.AUSSIE_RULES_TOTAL,
    TemplateIdsMapBC.BANDY_TOTAL,
    TemplateIdsMapBC.AMERICAN_FOOTBALL_TOTAL,
    TemplateIdsMapBC.SNOOKER_TOTAL,
    TemplateIdsMapBC.TABLE_TENNIS_TOTAL,
    TemplateIdsMapBC.DARTS_TOTAL,
    TemplateIdsMapBC.VOLLEYBALL_TOTAL,
    TemplateIdsMapBC.FUTSAL_TOTAL,
    TemplateIdsMapBC.BADMINTON_TOTAL,
    TemplateIdsMapBC.BEACH_SOCCER_TOTAL,
    TemplateIdsMapBC.CRICKET_DRAW_NO_BET_TOTAL,
    TemplateIdsMapBC.COUNTER_STRIKE_TOTAL,
    TemplateIdsMapBC.DOTA_2_TOTAL,
    TemplateIdsMapBC.LEAGUE_OF_LEGENDS_TOTAL,
    TemplateIdsMapBC.OVERWATCH_TOTAL,
    TemplateIdsMapBC.VALORANT_TOTAL,
    TemplateIdsMapBC.MOBILE_LEGENDS_TOTAL,
    TemplateIdsMapBC.KING_OF_GLORY_TOTAL,
    TemplateIdsMapBC.CROSSFIRE_TOTAL,
];
